import { post, get } from "../http.js";

export function getNewVersion(data) {
  return post({
    url: "/updateSoftware//getNewVersion",
    data: {
      ...data,
    },
  });
}
